/* tslint:disable */
/* eslint-disable */
/**
 * AI Secretary
 * AI-powered voice assistant platform for automated appointment scheduling, customer communication, and CRM integration
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { PagePhoneNumberResponseDTO } from '../models';
// @ts-ignore
import type { PhoneNumberCreateDTO } from '../models';
// @ts-ignore
import type { PhoneNumberResponseDTO } from '../models';
// @ts-ignore
import type { PhoneNumberUpdateDTO } from '../models';
/**
 * PhoneNumbersApi - axios parameter creator
 * @export
 */
export const PhoneNumbersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new phone number in the current organization. Requires \'phone:write\' permission.
         * @summary Create Phone Number
         * @param {PhoneNumberCreateDTO} phoneNumberCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPhoneNumberApiV1PhoneNumbersPost: async (phoneNumberCreateDTO: PhoneNumberCreateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'phoneNumberCreateDTO' is not null or undefined
            assertParamExists('createPhoneNumberApiV1PhoneNumbersPost', 'phoneNumberCreateDTO', phoneNumberCreateDTO)
            const localVarPath = `/api/v1/phone-numbers/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(phoneNumberCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new phone number in the current organization. Requires \'phone:write\' permission.
         * @summary Create Phone Number
         * @param {PhoneNumberCreateDTO} phoneNumberCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPhoneNumberApiV1PhoneNumbersPost_1: async (phoneNumberCreateDTO: PhoneNumberCreateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'phoneNumberCreateDTO' is not null or undefined
            assertParamExists('createPhoneNumberApiV1PhoneNumbersPost_1', 'phoneNumberCreateDTO', phoneNumberCreateDTO)
            const localVarPath = `/api/v1/phone-numbers/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(phoneNumberCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a phone number from the organization. Requires \'phone:write\' permission.
         * @summary Delete Phone Number
         * @param {string} phoneNumberId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePhoneNumberApiV1PhoneNumbersPhoneNumberIdDelete: async (phoneNumberId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'phoneNumberId' is not null or undefined
            assertParamExists('deletePhoneNumberApiV1PhoneNumbersPhoneNumberIdDelete', 'phoneNumberId', phoneNumberId)
            const localVarPath = `/api/v1/phone-numbers/{phone_number_id}`
                .replace(`{${"phone_number_id"}}`, encodeURIComponent(String(phoneNumberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a phone number from the organization. Requires \'phone:write\' permission.
         * @summary Delete Phone Number
         * @param {string} phoneNumberId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePhoneNumberApiV1PhoneNumbersPhoneNumberIdDelete_2: async (phoneNumberId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'phoneNumberId' is not null or undefined
            assertParamExists('deletePhoneNumberApiV1PhoneNumbersPhoneNumberIdDelete_2', 'phoneNumberId', phoneNumberId)
            const localVarPath = `/api/v1/phone-numbers/{phone_number_id}`
                .replace(`{${"phone_number_id"}}`, encodeURIComponent(String(phoneNumberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific phone number by ID. Requires \'phone:view\' permission.
         * @summary Get Phone Number
         * @param {string} phoneNumberId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPhoneNumberApiV1PhoneNumbersPhoneNumberIdGet: async (phoneNumberId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'phoneNumberId' is not null or undefined
            assertParamExists('getPhoneNumberApiV1PhoneNumbersPhoneNumberIdGet', 'phoneNumberId', phoneNumberId)
            const localVarPath = `/api/v1/phone-numbers/{phone_number_id}`
                .replace(`{${"phone_number_id"}}`, encodeURIComponent(String(phoneNumberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific phone number by ID. Requires \'phone:view\' permission.
         * @summary Get Phone Number
         * @param {string} phoneNumberId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPhoneNumberApiV1PhoneNumbersPhoneNumberIdGet_3: async (phoneNumberId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'phoneNumberId' is not null or undefined
            assertParamExists('getPhoneNumberApiV1PhoneNumbersPhoneNumberIdGet_3', 'phoneNumberId', phoneNumberId)
            const localVarPath = `/api/v1/phone-numbers/{phone_number_id}`
                .replace(`{${"phone_number_id"}}`, encodeURIComponent(String(phoneNumberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all phone numbers in the current user\'s organization. Requires \'phone:view\' permission.
         * @summary List Phone Numbers
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPhoneNumbersApiV1PhoneNumbersGet: async (limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/phone-numbers/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all phone numbers in the current user\'s organization. Requires \'phone:view\' permission.
         * @summary List Phone Numbers
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPhoneNumbersApiV1PhoneNumbersGet_4: async (limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/phone-numbers/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a phone number\'s information. Requires \'phone:write\' permission.
         * @summary Update Phone Number
         * @param {string} phoneNumberId 
         * @param {PhoneNumberUpdateDTO} phoneNumberUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePhoneNumberApiV1PhoneNumbersPhoneNumberIdPatch: async (phoneNumberId: string, phoneNumberUpdateDTO: PhoneNumberUpdateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'phoneNumberId' is not null or undefined
            assertParamExists('updatePhoneNumberApiV1PhoneNumbersPhoneNumberIdPatch', 'phoneNumberId', phoneNumberId)
            // verify required parameter 'phoneNumberUpdateDTO' is not null or undefined
            assertParamExists('updatePhoneNumberApiV1PhoneNumbersPhoneNumberIdPatch', 'phoneNumberUpdateDTO', phoneNumberUpdateDTO)
            const localVarPath = `/api/v1/phone-numbers/{phone_number_id}`
                .replace(`{${"phone_number_id"}}`, encodeURIComponent(String(phoneNumberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(phoneNumberUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a phone number\'s information. Requires \'phone:write\' permission.
         * @summary Update Phone Number
         * @param {string} phoneNumberId 
         * @param {PhoneNumberUpdateDTO} phoneNumberUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePhoneNumberApiV1PhoneNumbersPhoneNumberIdPatch_5: async (phoneNumberId: string, phoneNumberUpdateDTO: PhoneNumberUpdateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'phoneNumberId' is not null or undefined
            assertParamExists('updatePhoneNumberApiV1PhoneNumbersPhoneNumberIdPatch_5', 'phoneNumberId', phoneNumberId)
            // verify required parameter 'phoneNumberUpdateDTO' is not null or undefined
            assertParamExists('updatePhoneNumberApiV1PhoneNumbersPhoneNumberIdPatch_5', 'phoneNumberUpdateDTO', phoneNumberUpdateDTO)
            const localVarPath = `/api/v1/phone-numbers/{phone_number_id}`
                .replace(`{${"phone_number_id"}}`, encodeURIComponent(String(phoneNumberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(phoneNumberUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PhoneNumbersApi - functional programming interface
 * @export
 */
export const PhoneNumbersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PhoneNumbersApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new phone number in the current organization. Requires \'phone:write\' permission.
         * @summary Create Phone Number
         * @param {PhoneNumberCreateDTO} phoneNumberCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPhoneNumberApiV1PhoneNumbersPost(phoneNumberCreateDTO: PhoneNumberCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PhoneNumberResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPhoneNumberApiV1PhoneNumbersPost(phoneNumberCreateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PhoneNumbersApi.createPhoneNumberApiV1PhoneNumbersPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new phone number in the current organization. Requires \'phone:write\' permission.
         * @summary Create Phone Number
         * @param {PhoneNumberCreateDTO} phoneNumberCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPhoneNumberApiV1PhoneNumbersPost_1(phoneNumberCreateDTO: PhoneNumberCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PhoneNumberResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPhoneNumberApiV1PhoneNumbersPost_1(phoneNumberCreateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PhoneNumbersApi.createPhoneNumberApiV1PhoneNumbersPost_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a phone number from the organization. Requires \'phone:write\' permission.
         * @summary Delete Phone Number
         * @param {string} phoneNumberId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePhoneNumberApiV1PhoneNumbersPhoneNumberIdDelete(phoneNumberId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePhoneNumberApiV1PhoneNumbersPhoneNumberIdDelete(phoneNumberId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PhoneNumbersApi.deletePhoneNumberApiV1PhoneNumbersPhoneNumberIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a phone number from the organization. Requires \'phone:write\' permission.
         * @summary Delete Phone Number
         * @param {string} phoneNumberId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePhoneNumberApiV1PhoneNumbersPhoneNumberIdDelete_2(phoneNumberId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePhoneNumberApiV1PhoneNumbersPhoneNumberIdDelete_2(phoneNumberId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PhoneNumbersApi.deletePhoneNumberApiV1PhoneNumbersPhoneNumberIdDelete_2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a specific phone number by ID. Requires \'phone:view\' permission.
         * @summary Get Phone Number
         * @param {string} phoneNumberId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPhoneNumberApiV1PhoneNumbersPhoneNumberIdGet(phoneNumberId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PhoneNumberResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPhoneNumberApiV1PhoneNumbersPhoneNumberIdGet(phoneNumberId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PhoneNumbersApi.getPhoneNumberApiV1PhoneNumbersPhoneNumberIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a specific phone number by ID. Requires \'phone:view\' permission.
         * @summary Get Phone Number
         * @param {string} phoneNumberId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPhoneNumberApiV1PhoneNumbersPhoneNumberIdGet_3(phoneNumberId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PhoneNumberResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPhoneNumberApiV1PhoneNumbersPhoneNumberIdGet_3(phoneNumberId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PhoneNumbersApi.getPhoneNumberApiV1PhoneNumbersPhoneNumberIdGet_3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all phone numbers in the current user\'s organization. Requires \'phone:view\' permission.
         * @summary List Phone Numbers
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPhoneNumbersApiV1PhoneNumbersGet(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagePhoneNumberResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPhoneNumbersApiV1PhoneNumbersGet(limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PhoneNumbersApi.listPhoneNumbersApiV1PhoneNumbersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all phone numbers in the current user\'s organization. Requires \'phone:view\' permission.
         * @summary List Phone Numbers
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPhoneNumbersApiV1PhoneNumbersGet_4(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagePhoneNumberResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPhoneNumbersApiV1PhoneNumbersGet_4(limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PhoneNumbersApi.listPhoneNumbersApiV1PhoneNumbersGet_4']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a phone number\'s information. Requires \'phone:write\' permission.
         * @summary Update Phone Number
         * @param {string} phoneNumberId 
         * @param {PhoneNumberUpdateDTO} phoneNumberUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePhoneNumberApiV1PhoneNumbersPhoneNumberIdPatch(phoneNumberId: string, phoneNumberUpdateDTO: PhoneNumberUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PhoneNumberResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePhoneNumberApiV1PhoneNumbersPhoneNumberIdPatch(phoneNumberId, phoneNumberUpdateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PhoneNumbersApi.updatePhoneNumberApiV1PhoneNumbersPhoneNumberIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a phone number\'s information. Requires \'phone:write\' permission.
         * @summary Update Phone Number
         * @param {string} phoneNumberId 
         * @param {PhoneNumberUpdateDTO} phoneNumberUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePhoneNumberApiV1PhoneNumbersPhoneNumberIdPatch_5(phoneNumberId: string, phoneNumberUpdateDTO: PhoneNumberUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PhoneNumberResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePhoneNumberApiV1PhoneNumbersPhoneNumberIdPatch_5(phoneNumberId, phoneNumberUpdateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PhoneNumbersApi.updatePhoneNumberApiV1PhoneNumbersPhoneNumberIdPatch_5']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PhoneNumbersApi - factory interface
 * @export
 */
export const PhoneNumbersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PhoneNumbersApiFp(configuration)
    return {
        /**
         * Create a new phone number in the current organization. Requires \'phone:write\' permission.
         * @summary Create Phone Number
         * @param {PhoneNumberCreateDTO} phoneNumberCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPhoneNumberApiV1PhoneNumbersPost(phoneNumberCreateDTO: PhoneNumberCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PhoneNumberResponseDTO> {
            return localVarFp.createPhoneNumberApiV1PhoneNumbersPost(phoneNumberCreateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new phone number in the current organization. Requires \'phone:write\' permission.
         * @summary Create Phone Number
         * @param {PhoneNumberCreateDTO} phoneNumberCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPhoneNumberApiV1PhoneNumbersPost_1(phoneNumberCreateDTO: PhoneNumberCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PhoneNumberResponseDTO> {
            return localVarFp.createPhoneNumberApiV1PhoneNumbersPost_1(phoneNumberCreateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a phone number from the organization. Requires \'phone:write\' permission.
         * @summary Delete Phone Number
         * @param {string} phoneNumberId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePhoneNumberApiV1PhoneNumbersPhoneNumberIdDelete(phoneNumberId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePhoneNumberApiV1PhoneNumbersPhoneNumberIdDelete(phoneNumberId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a phone number from the organization. Requires \'phone:write\' permission.
         * @summary Delete Phone Number
         * @param {string} phoneNumberId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePhoneNumberApiV1PhoneNumbersPhoneNumberIdDelete_2(phoneNumberId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePhoneNumberApiV1PhoneNumbersPhoneNumberIdDelete_2(phoneNumberId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific phone number by ID. Requires \'phone:view\' permission.
         * @summary Get Phone Number
         * @param {string} phoneNumberId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPhoneNumberApiV1PhoneNumbersPhoneNumberIdGet(phoneNumberId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PhoneNumberResponseDTO> {
            return localVarFp.getPhoneNumberApiV1PhoneNumbersPhoneNumberIdGet(phoneNumberId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific phone number by ID. Requires \'phone:view\' permission.
         * @summary Get Phone Number
         * @param {string} phoneNumberId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPhoneNumberApiV1PhoneNumbersPhoneNumberIdGet_3(phoneNumberId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PhoneNumberResponseDTO> {
            return localVarFp.getPhoneNumberApiV1PhoneNumbersPhoneNumberIdGet_3(phoneNumberId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List all phone numbers in the current user\'s organization. Requires \'phone:view\' permission.
         * @summary List Phone Numbers
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPhoneNumbersApiV1PhoneNumbersGet(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PagePhoneNumberResponseDTO> {
            return localVarFp.listPhoneNumbersApiV1PhoneNumbersGet(limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List all phone numbers in the current user\'s organization. Requires \'phone:view\' permission.
         * @summary List Phone Numbers
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPhoneNumbersApiV1PhoneNumbersGet_4(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PagePhoneNumberResponseDTO> {
            return localVarFp.listPhoneNumbersApiV1PhoneNumbersGet_4(limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a phone number\'s information. Requires \'phone:write\' permission.
         * @summary Update Phone Number
         * @param {string} phoneNumberId 
         * @param {PhoneNumberUpdateDTO} phoneNumberUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePhoneNumberApiV1PhoneNumbersPhoneNumberIdPatch(phoneNumberId: string, phoneNumberUpdateDTO: PhoneNumberUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PhoneNumberResponseDTO> {
            return localVarFp.updatePhoneNumberApiV1PhoneNumbersPhoneNumberIdPatch(phoneNumberId, phoneNumberUpdateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a phone number\'s information. Requires \'phone:write\' permission.
         * @summary Update Phone Number
         * @param {string} phoneNumberId 
         * @param {PhoneNumberUpdateDTO} phoneNumberUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePhoneNumberApiV1PhoneNumbersPhoneNumberIdPatch_5(phoneNumberId: string, phoneNumberUpdateDTO: PhoneNumberUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PhoneNumberResponseDTO> {
            return localVarFp.updatePhoneNumberApiV1PhoneNumbersPhoneNumberIdPatch_5(phoneNumberId, phoneNumberUpdateDTO, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PhoneNumbersApi - object-oriented interface
 * @export
 * @class PhoneNumbersApi
 * @extends {BaseAPI}
 */
export class PhoneNumbersApi extends BaseAPI {
    /**
     * Create a new phone number in the current organization. Requires \'phone:write\' permission.
     * @summary Create Phone Number
     * @param {PhoneNumberCreateDTO} phoneNumberCreateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PhoneNumbersApi
     */
    public createPhoneNumberApiV1PhoneNumbersPost(phoneNumberCreateDTO: PhoneNumberCreateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return PhoneNumbersApiFp(this.configuration).createPhoneNumberApiV1PhoneNumbersPost(phoneNumberCreateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new phone number in the current organization. Requires \'phone:write\' permission.
     * @summary Create Phone Number
     * @param {PhoneNumberCreateDTO} phoneNumberCreateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PhoneNumbersApi
     */
    public createPhoneNumberApiV1PhoneNumbersPost_1(phoneNumberCreateDTO: PhoneNumberCreateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return PhoneNumbersApiFp(this.configuration).createPhoneNumberApiV1PhoneNumbersPost_1(phoneNumberCreateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a phone number from the organization. Requires \'phone:write\' permission.
     * @summary Delete Phone Number
     * @param {string} phoneNumberId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PhoneNumbersApi
     */
    public deletePhoneNumberApiV1PhoneNumbersPhoneNumberIdDelete(phoneNumberId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return PhoneNumbersApiFp(this.configuration).deletePhoneNumberApiV1PhoneNumbersPhoneNumberIdDelete(phoneNumberId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a phone number from the organization. Requires \'phone:write\' permission.
     * @summary Delete Phone Number
     * @param {string} phoneNumberId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PhoneNumbersApi
     */
    public deletePhoneNumberApiV1PhoneNumbersPhoneNumberIdDelete_2(phoneNumberId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return PhoneNumbersApiFp(this.configuration).deletePhoneNumberApiV1PhoneNumbersPhoneNumberIdDelete_2(phoneNumberId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific phone number by ID. Requires \'phone:view\' permission.
     * @summary Get Phone Number
     * @param {string} phoneNumberId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PhoneNumbersApi
     */
    public getPhoneNumberApiV1PhoneNumbersPhoneNumberIdGet(phoneNumberId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return PhoneNumbersApiFp(this.configuration).getPhoneNumberApiV1PhoneNumbersPhoneNumberIdGet(phoneNumberId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific phone number by ID. Requires \'phone:view\' permission.
     * @summary Get Phone Number
     * @param {string} phoneNumberId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PhoneNumbersApi
     */
    public getPhoneNumberApiV1PhoneNumbersPhoneNumberIdGet_3(phoneNumberId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return PhoneNumbersApiFp(this.configuration).getPhoneNumberApiV1PhoneNumbersPhoneNumberIdGet_3(phoneNumberId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all phone numbers in the current user\'s organization. Requires \'phone:view\' permission.
     * @summary List Phone Numbers
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PhoneNumbersApi
     */
    public listPhoneNumbersApiV1PhoneNumbersGet(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return PhoneNumbersApiFp(this.configuration).listPhoneNumbersApiV1PhoneNumbersGet(limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all phone numbers in the current user\'s organization. Requires \'phone:view\' permission.
     * @summary List Phone Numbers
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PhoneNumbersApi
     */
    public listPhoneNumbersApiV1PhoneNumbersGet_4(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return PhoneNumbersApiFp(this.configuration).listPhoneNumbersApiV1PhoneNumbersGet_4(limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a phone number\'s information. Requires \'phone:write\' permission.
     * @summary Update Phone Number
     * @param {string} phoneNumberId 
     * @param {PhoneNumberUpdateDTO} phoneNumberUpdateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PhoneNumbersApi
     */
    public updatePhoneNumberApiV1PhoneNumbersPhoneNumberIdPatch(phoneNumberId: string, phoneNumberUpdateDTO: PhoneNumberUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return PhoneNumbersApiFp(this.configuration).updatePhoneNumberApiV1PhoneNumbersPhoneNumberIdPatch(phoneNumberId, phoneNumberUpdateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a phone number\'s information. Requires \'phone:write\' permission.
     * @summary Update Phone Number
     * @param {string} phoneNumberId 
     * @param {PhoneNumberUpdateDTO} phoneNumberUpdateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PhoneNumbersApi
     */
    public updatePhoneNumberApiV1PhoneNumbersPhoneNumberIdPatch_5(phoneNumberId: string, phoneNumberUpdateDTO: PhoneNumberUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return PhoneNumbersApiFp(this.configuration).updatePhoneNumberApiV1PhoneNumbersPhoneNumberIdPatch_5(phoneNumberId, phoneNumberUpdateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}

